/* eslint-disable react/no-danger */
import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import PropTypes from 'prop-types';
import {clearAllBodyScrollLocks} from "body-scroll-lock";
import {stripTagsModified, filterHeadline, filterHTML} from "../../helpers/filters";
import {trackEventByUrl} from "../../helpers/events";
import ReactVideoModal from "../ReactVideoModal/ReactVideoModal";

class KnowledgeCenterArticle extends Component {
    static propTypes = {
        // eslint-disable-next-line react/forbid-prop-types
        post: PropTypes.object.isRequired,
        toggleKeyword: PropTypes.func.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        location: PropTypes.object.isRequired,
        imageLoaded: PropTypes.func.isRequired,
        imagesHaveAllRendered: PropTypes.bool,
        isFeatured: PropTypes.bool,
    };

    static defaultProps = {
        imagesHaveAllRendered: false,
        isFeatured: false
    };

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
    }

    state = {
        modalIsOpen: false,
        imageLoaded: false
    };

    getAnchorClass = (defaultClass = '') => {
        const {post} = this.props;

        if (!post.linkDisplay || (post.linkDisplay && post.linkDisplay === 'default')) return defaultClass;

        if (post.linkDisplay === 'pdf') {
            return `text-cta kc__pdfLink`;
        }

        if (post.linkDisplay === 'video') {
            return `text-cta kc__videoLink`;
        }

        if (post.linkDisplay === 'readmore') {
            return `text-cta kc__articleLink`;
        }

        return '';
    };

    getAnchorText = (defaultText = '', overrideText = '') => {
        const {post} = this.props;

        // Prefer override text
        if (overrideText) return overrideText;

        if (!post.linkDisplay || (post.linkDisplay && post.linkDisplay === 'default')) return defaultText;

        if (post.linkDisplay === 'pdf') {
            return `Read the Case Study`;
        }

        if (post.linkDisplay === 'video') {
            return 'Watch Video';
        }

        if (post.linkDisplay === 'readmore') {
            return 'Read More';
        }

        return defaultText;
    };

    /**
     * Strip all tags and truncate text down to 300 max characters.
     *
     * @param post
     * @returns {JSX.Element|null}
     */
    getExcerpt = (post) => {
        if (!post) return null;

        if (post.excerpt && post.excerpt.length > 0) {
            return (<div className="articleExcerpt" dangerouslySetInnerHTML={{__html: post.excerpt}}/>);
        }

        const content = post.body;
        console.info("post", post);

        if (!content) return null;

        let filtered = filterHTML(stripTagsModified(content, []));

        if (filtered.length >= 300) {
            filtered = `<p>${filtered.substring(0, 297)}...</p>`;
        }

        return (<div className="articleExcerpt" dangerouslySetInnerHTML={{__html: filtered}}/>);
    };

    getSecondaryLink = () => {
        const {post} = this.props;

        if (!post.secondary_link) return null;

        return post.secondary_link.replace('//pdf/', '/pdf/');
    };

    openModal = () => {
        this.setState({modalIsOpen: true});
    };

    scrollToAnchor = () => {
        clearAllBodyScrollLocks();

        // Don't scroll if CSS ID is missing or URL hash is missing
        if (!this.myRef || !this.props.post.cssId || !this.props.location.hash) return;

        // Don't scroll if Hash doesn't match
        if (this.props.location.hash !== `#${this.props.post.cssId}`) return;

        this.myRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        })
    };

    renderFeaturedArticle = (post, toggleKeyword, imageLoaded, imagesHaveAllRendered, isArticleLink, downloadableFile, validVideoLink, secondaryLink) => (
        <article key={`kcpost_${post.id}`} id={post.cssId} ref={this.myRef} className="knowledgeCenter__featuredArticle">
            {validVideoLink ? <ReactVideoModal uri={secondaryLink}
                                               inline={false}
                                               eventMetaTitle={post.title}
                                               eventButtonTitle={post.list_link_title || 'Watch Video'}
                                               isOpen={this.state.modalIsOpen}
                                               onClose={() => this.setState({modalIsOpen: false})}/> : null}

            <div className="knowledgeCenter__articleText">
                {post.subtitle ? (
                    <p className="articleSubtitle">{post.subtitle}</p>
                ) : null}

                {post.title && (
                    <h3 dangerouslySetInnerHTML={{__html: filterHeadline(post.title)}}/>
                )}

                {this.getExcerpt(post)}

                {!validVideoLink && !secondaryLink && (
                    <a className={this.getAnchorClass('text-cta')} href={post.permalink}>{this.getAnchorText('Read More')}</a>
                )}
                {!validVideoLink && secondaryLink && (
                    <a target={secondaryLink !== 'internal:/' ? '_blank' : '_self'}  className={this.getAnchorClass('text-cta')}
                       rel="noreferrer noopener"
                       onClick={() => trackEventByUrl(secondaryLink !== 'internal:/' ? secondaryLink : downloadableFile, post.list_link_title || 'Read More')}
                       href={secondaryLink !== 'internal:/' ? secondaryLink : downloadableFile}>
                        {this.getAnchorText('Read More', post.list_link_title)}
                    </a>
                )}
                {validVideoLink ? (
                    <a className={this.getAnchorClass('text-cta')} href={post.permalink}>{this.getAnchorText('Read More', post.list_link_title)}</a>
                ) : null}

                {post.tags && post.tags.length ? (
                    <div className="kcpost__keywords">
                        {post.tags.map(tag => (
                            <button key={`kcpost_${post.id}_keyword_${tag.slug.trim()}`} className="kcpost__keyword" onClick={e => toggleKeyword(e, tag.name.trim(), true)}>
                                {tag.name.trim()}
                            </button>
                        ))}
                    </div>
                ) : null}

            </div>

            {post.featured_image && post.featured_image.url ? (
                <div className="knowledgeCenter__articleImage">
                    <img onLoad={imageLoaded}
                        src={post.featured_image.url}
                        alt={post.featured_image.alt}
                    />
                </div>
            ) : null}

        </article>
    );

    render() {
        const {post, toggleKeyword, imageLoaded, imagesHaveAllRendered} = this.props;

        const isArticleLink = post.category_selection === 'article';

        // TODO: implement in Twill side
        const downloadableFile = post.downloadableFile && post.downloadableFile.entity && post.downloadableFile.entity.fieldFile && post.downloadableFile.entity.fieldFile.entity && post.downloadableFile.entity.fieldFile.entity.url ? post.downloadableFile.entity.fieldFile.entity.url : '';

        if (imagesHaveAllRendered) {
            this.scrollToAnchor();
        }

        const secondaryLink = this.getSecondaryLink();

        // Attempt to parse a vimeo/youtube link from the secondary_link field
        const videoLink = ReactVideoModal.getVideoId(secondaryLink)
        const validVideoLink = videoLink && secondaryLink && secondaryLink !== 'internal:/';

        // Render Featured Article variant
        if (this.props.isFeatured) {
            return this.renderFeaturedArticle(post, toggleKeyword, imageLoaded, imagesHaveAllRendered, isArticleLink, downloadableFile, validVideoLink, secondaryLink);
        }

        return (
            <article key={`kcpost_${post.id}`} id={post.cssId} ref={this.myRef}>
                {validVideoLink ? <ReactVideoModal uri={secondaryLink}
                                                   inline={false}
                                                   eventMetaTitle={post.title}
                                                   eventButtonTitle={post.list_link_title || 'Watch Video'}
                                                   isOpen={this.state.modalIsOpen}
                                                   onClose={() => this.setState({modalIsOpen: false})}/> : null}
                {post.featured_image && post.featured_image.url ? (
                    <img onLoad={imageLoaded}
                         src={post.featured_image.url}
                         alt={post.featured_image.alt}
                         className="knowledgeCenter__articleImage"
                    />
                ) : null}

                <div className="knowledgeCenter__articleText">
                    {post.subtitle ? (
                        <p className="articleSubtitle">{post.subtitle}</p>
                    ) : null}

                    {post.title && (
                        <h3 dangerouslySetInnerHTML={{__html: filterHeadline(post.title)}}/>
                    )}

                    {this.getExcerpt(post)}

                    {!validVideoLink && !secondaryLink && (
                        <a className={this.getAnchorClass('text-cta')} href={post.permalink}>
                            {this.getAnchorText('Read More')}
                        </a>
                    )}
                    {!validVideoLink && secondaryLink && (
                        <a target={secondaryLink !== 'internal:/' ? '_blank' : '_self'}  className={this.getAnchorClass('text-cta')}
                           rel="noreferrer noopener"
                           onClick={() => trackEventByUrl(secondaryLink !== 'internal:/' ? secondaryLink : downloadableFile, post.list_link_title || 'Read More')}
                           href={secondaryLink !== 'internal:/' ? secondaryLink : downloadableFile}>
                            {this.getAnchorText('Read More', post.list_link_title)}
                        </a>
                    )}
                    {validVideoLink ? (
                        <a className={this.getAnchorClass('text-cta')} href={post.permalink}>
                            {this.getAnchorText('Read More', post.list_link_title)}
                        </a>
                    ) : null}

                    {post.tags && post.tags.length ? (
                        <div className="kcpost__keywords kcpost__keywords--no-top-border">
                            {post.tags.map(tag => (
                                <button key={`kcpost_${post.id}_keyword_${tag.slug.trim()}`} className="kcpost__keyword" onClick={e => toggleKeyword(e, tag.name.trim(), true)}>
                                    {tag.name.trim()}
                                </button>
                            ))}
                        </div>
                    ) : null}

                </div>

            </article>
        )
    }
}

export default withRouter(KnowledgeCenterArticle);



// WEBPACK FOOTER //
// ./frontend/components/KnowledgeCenter/KnowledgeCenterArticle.jsx